/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { ConfigService, EnvironmentService } from 'sis-common';
import { FeedbackFeatureToggleService } from '../feedback/feedback-feature-toggle.service';
import { UniversityService } from '../service/university.service';

@Component({
    selector: 'sis-footer',
    templateUrl: './footer.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FooterComponent {
    @Input({ required: true }) aboutHref: string;

    constructor(
        private transloco: TranslocoService,
        private universityService: UniversityService,
        private configService: ConfigService,
        private environmentService: EnvironmentService,
        private readonly feedbackFeatureToggleService: FeedbackFeatureToggleService,
    ) {}

    registryDescriptionUrl = toSignal(
        this.universityService.getCurrentUniversitySettings().pipe(
            map(settings => settings?.registryDescriptionUrl),
            catchError(() => of(null)),
        ),
    );

    feedbackEnabled = toSignal(this.feedbackFeatureToggleService.getFeedbackEnabled());

    frontendName = this.environmentService.frontendName.toLowerCase();
    featureToggleAllowed = this.configService.get().isTestModeEnabled;
    featureToggleUrl = `/${this.frontendName}/feature-toggle`;
    feedbackState = `${this.frontendName}.logged-in.feedback`;

    currentLanguage = toSignal(
        this.transloco.langChanges$.pipe(startWith(this.transloco.getActiveLang() ?? this.transloco.getDefaultLang())),
    );
}
